// Minimal nested references — display labels + allocation-form prefill.
interface AllocationAccountCodeRef {
  id: number
  code: string
  description: string
}

interface AllocationCategoryRef {
  id: number
  name: string
}

export interface ItemCostAllocationConstructor {
  budgetId: number // from cost_allocations[].budget.id — form prefill key
  amount: string // decimal string, e.g. "255.31000000"
  accountCode: AllocationAccountCodeRef // from budget.account_code
  primaryCategory: AllocationCategoryRef // from budget.department.branch
  secondaryCategory: AllocationCategoryRef // from budget.department
}

export class ItemCostAllocation {
  readonly budgetId: number
  readonly amount: string
  readonly accountCode: AllocationAccountCodeRef
  readonly primaryCategory: AllocationCategoryRef
  readonly secondaryCategory: AllocationCategoryRef

  constructor(data: ItemCostAllocationConstructor) {
    this.budgetId = data.budgetId
    this.amount = data.amount
    this.accountCode = data.accountCode
    this.primaryCategory = data.primaryCategory
    this.secondaryCategory = data.secondaryCategory
  }

  // "6000 - Supplies" (BHV-011, BHV-050 sub-rows)
  get accountCodeLabel(): string {
    return `${this.accountCode.code} - ${this.accountCode.description}`
  }

  get amountValue(): number {
    return parseFloat(this.amount)
  }
}
